﻿import * as React from "react";
import * as dtos from "dtos";
import {TimelineItem, ItemData} from "./timeline-item";

export interface Props extends React.Props<any> {
	ArchiveDate: Date | string | null;
	DateCreated: Date | string | null;
	History: dtos.IRecordDTO[];
    ShowSource: boolean;
}

export function Timeline(props: Props): JSX.Element {
    let records: ItemData[] = [];
    
    for (let record of props.History) {
    	// This whole switch is completely pointless but it makes TypeScript happy about the types
    	switch (record.type) {
			case "stage-record":
				records.push({type: "stage-record", data: record as dtos.IStageRecordDTO});
				break;
			case "trigger-record":
				records.push({type: "trigger-record", data: record as dtos.ITriggerRecordDTO});
				break;
            case "archive-change-record":
                records.push({type: "archive-record", data: record as dtos.IArchiveRecordDTO});
                break;
			default:
                const recordType: never = record.type;
                const message = `Unrecognized record type ${recordType} in Timeline component. Cannot push records.`
				
                console.error(message);
                
				throw new Error(message);
		}
	}
    
    // Add the creation date last so it shows up at the very bottom of the timeline
	if (props.DateCreated) {
		records.push({type: "creation-date", date: props.DateCreated});
	}

	return (
		<ul className="timeline">
			{records.map((record, index) => 
                <TimelineItem key={index} index={index} record={record} showSource={props.ShowSource} />)}
		</ul>
	)
}
